var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCouponBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.06183 17.927L7.36987 16.9227C6.94046 16.6679 6.72575 16.5404 6.48747 16.5331C6.22997 16.5251 6.01146 16.6473 5.54745 16.9227C5.02778 17.2312 3.99443 18.0809 3.32602 17.6757C2.91699 17.4277 2.91699 16.7979 2.91699 15.5382V6.66675C2.91699 4.30972 2.91699 3.13121 3.64923 2.39898C4.38146 1.66675 5.55997 1.66675 7.91699 1.66675H12.0837C14.4407 1.66675 15.6192 1.66675 16.3514 2.39898C17.0837 3.13121 17.0837 4.30972 17.0837 6.66675V15.5382C17.0837 16.7979 17.0837 17.4277 16.6747 17.6757C16.0062 18.0809 14.9729 17.2312 14.4532 16.9227C14.0238 16.6679 13.8091 16.5404 13.5708 16.5331C13.3133 16.5251 13.0948 16.6473 12.6308 16.9227L10.9388 17.927C10.4825 18.1979 10.2542 18.3333 10.0003 18.3333C9.74641 18.3333 9.51816 18.1979 9.06183 17.927Z",
    stroke: "#3F3F3F",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 6.66675L7.5 11.6667",
    stroke: "#3F3F3F",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 11.6667H12.4925M7.50748 6.66675H7.5",
    stroke: "#3F3F3F",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCouponBlack);
export default __webpack_public_path__ + "static/media/coupon-black.07706ce45d70e0e66bbc20d3f4f46575.svg";
export { ForwardRef as ReactComponent };